/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { RenderTableColumn } from './RenderTableColumn';
import type { RenderTableCoverage } from './RenderTableCoverage';
import type { RenderTableDebug } from './RenderTableDebug';
import type { RenderTableRow } from './RenderTableRow';
import type { RenderTableValidationIssue } from './RenderTableValidationIssue';

export type RenderTableOutput = {
    cluster_id: string;
    status: RenderTableOutput.status;
    view_type: RenderTableOutput.view_type;
    row_grain: RenderTableOutput.row_grain;
    columns: Array<RenderTableColumn>;
    total_row_count: number;
    returned_row_count: number;
    truncated?: boolean;
    limit: number;
    warnings?: Array<string>;
    validation_issues?: Array<RenderTableValidationIssue>;
    coverage?: (Array<RenderTableCoverage> | null);
    rows?: Array<RenderTableRow>;
    recommended_next_call?: (Record<string, any> | null);
    debug?: (RenderTableDebug | null);
};

export namespace RenderTableOutput {

    export enum status {
        SUCCESS = 'success',
        EMPTY = 'empty',
        VALIDATION_ERROR = 'validation_error',
    }

    export enum view_type {
        SNAPSHOT = 'snapshot',
        TIME_SERIES = 'time_series',
    }

    export enum row_grain {
        ENTITY = 'entity',
        GROUPS = 'groups',
        TOTAL = 'total',
    }


}

